import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  onNavigateServiceDesk(){
    window.open("https://jira.arvato-support.com/servicedesk/customer/portal/151", "_blank");
  }

  onNavigateSharePoint() {
    window.open("https://extranetscm.arvato.com/cim/projekte/bentley/Bentley%20Documents/Forms/AllItems.aspx", "_blank");
  }
}
